export function getRollingReviewPeriod(
  date: Date = new Date(),
  requestedTimeZone = "Asia/Shanghai"
) {
  const timeZone = (() => {
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: requestedTimeZone }).format(date);
      return requestedTimeZone;
    } catch {
      return "Asia/Shanghai";
    }
  })();
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(date);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    Number(parts.find((part) => part.type === type)?.value ?? 0);
  const year = value("year");
  const month = value("month");
  const day = value("day");
  const end = [year, String(month).padStart(2, "0"), String(day).padStart(2, "0")].join("-");
  const startDate = new Date(Date.UTC(year, month - 1, day - 6));
  const start = startDate.toISOString().slice(0, 10);
  return { start, end, timeZone };
}
